import { useMemo } from 'react';
import { URL_DOMAIN_EPG } from 'utils/ConstantsAndNum';

const useClientId = () => {
  const clientId = useMemo(() => {
    const hostname = window.location.hostname;
    
    return hostname === URL_DOMAIN_EPG
      ? "pao-admision-epg-web"
      : "pao-admision-web";
  }, []);

  return {
    clientId,
    isClientIdEpg: clientId === "pao-admision-epg-web"
  };
};

export default useClientId;
